import { format, parseISO } from 'date-fns';
import isToday from 'date-fns/isToday';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { useTranslation } from '@lyearn/i18n';
import { EventUnion } from '@/types/schema';

const useTimeConversions = (event: EventUnion) => {
  const { i18n } = useTranslation();

  const startTime = event?.startTime;
  const endTime = event?.endTime;
  const registrationCloseTime = Date.parse(event?.registrationCloseTime!);

  if (!startTime || !endTime) {
    return {};
  }

  const startDay = format(parseISO(startTime!), 'd');
  const startMonth = format(parseISO(startTime!), 'MMM');

  const startDate = new Date(startTime);

  const eventStartTime = startDate.toLocaleTimeString(i18n.language, {
    hour: 'numeric',
    minute: '2-digit',
  });

  const eventDay = startDate.toLocaleDateString(i18n.language, {
    weekday: 'short',
  });

  const eventTimezone = startDate
    ? startDate.toTimeString().split('(')[1]?.match(/[A-Z]/g)?.join('')
    : '';

  const startTimeInMilliseconds = Date.parse(startTime);
  const endTimeInMilliseconds = Date.parse(endTime);

  const duration = (endTimeInMilliseconds - startTimeInMilliseconds) / 1000;

  const eventTime = `${formatDate(startDate, DateFormat.DayDateTime)} ${eventTimezone}`;

  return {
    startDay,
    startMonth,
    duration,
    startTimeInMilliseconds,
    eventTime,
    isRegistrationOpen: registrationCloseTime > Date.now(),
    eventStartTime,
    eventDay,
    isEventToday: isToday(startTimeInMilliseconds),
  };
};

export default useTimeConversions;
